import React from 'react';
import { IArticleItem } from "../interfaces/types";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

interface ArticleListItemProps {
    article: IArticleItem;
}

interface ArticleListItemImageProps {
    imageUrl: string;
    cssClass?: string;
}

export const ArticleListItemImage: React.FC<ArticleListItemImageProps> = ({ imageUrl, cssClass }) => { 
    return imageUrl !== null && imageUrl !== "" ? <div className={`article-listing-image ${cssClass}`}><img src={imageUrl} alt={''} /></div> : null
}

export const ArticleListItem: React.FC<ArticleListItemProps> = ({ article }) => {
    return (
        <>
            <div className="article-listing-item stack-sm">
                <ArticleListItemImage imageUrl={article.imageUrl}/>
                <div className="article-listing-info">
                    <div className="stack-sm"> 
                        <h3>
                            {
                                article.link != "" ?
                                    <a href={article.link} dangerouslySetInnerHTML={{ __html: article.title }}></a> : <span dangerouslySetInnerHTML={{ __html: article.title }}></span>
                            }
                        </h3>
                        <div className="rich-text" dangerouslySetInnerHTML={{ __html: article.description }} />
                        <p className="small">{dayjs.utc(article.publishDate).format('MMMM DD, YYYY')}</p>
                    </div>
                    
                </div>
            </div>
        </>
    )
}